/**
 * SoloBlock — мобильная карточка соло-тарифа: шапка + крупная фикс. цена.
 */

import {User} from 'lucide-react';

import {formatNumber} from '@utils/format';

import {CardHead} from '../CardHead';

type SoloBlockProps = {
  version: number;
  price: number;
  onEdit: () => void;
};

export const SoloBlock = ({version, price, onEdit}: SoloBlockProps) => (
  <div className="rounded-[15px] border border-skr-line bg-card px-[17px] py-4">
    <CardHead
      icon={<User className="size-5" strokeWidth={1.7} />}
      iconClassName="bg-accent text-primary"
      title="Соло-врач"
      subtitle={`фикс. в месяц · ${version === 0 ? 'не задан' : `v${version}`}`}
      onEdit={onEdit}
    />
    <div className="mt-3.5 flex items-baseline gap-[7px]">
      <span className="font-mono text-[30px] font-semibold -tracking-[.02em]">
        {formatNumber(price)}
      </span>
      <span className="text-[13px] text-muted-foreground">сом / месяц</span>
    </div>
  </div>
);
